import { createContext, useContext } from "react";
import type { EditorInput } from "./types";

export interface EditorInputsContextValue {
  inputs: EditorInput[];
}

export const EditorInputsContext =
  createContext<EditorInputsContextValue | null>(null);

export function useEditorInputs(): EditorInput[] {
  return useContext(EditorInputsContext)?.inputs ?? [];
}
